<template>
  <div class="h-full">
    <div class="h-full" v-if="loaded">
      <div class="claim-content h-full flex flex-column">
        <LayoutTopNav :claim-by-id="claim" @update="getClaim" />
        <div class="h-full flex">
          <div class="left-layout col-md-3">
            <div class="container">
              <div class="container">
                <div class="job-info mt-4">
                  <div class="row pb-3">
                    <div class="col-md-6">
                      <router-link :to="`/jobs/edit/${claim.job_id}`" target="_blank">
                        <span class="job_ref_id">{{ claim.job.ref_id }}</span>
                      </router-link>
                      <br />
                      <span class="job_title">{{ claim.job.source.name }}</span>
                    </div>
                    <div class="col-md-6">
                      <span class="job_title">Total price</span><br />
                      <span class="job_content">${{ claim.job.total_price.slice(0, -3) }}</span>
                    </div>
                  </div>
                </div>
                <div class=" pb-2 flex">
                  <span class="price-per-row">
                    <span class="job_title">Per hour</span><br />
                    <span class="job_content">${{ Math.round(claim.job.price_per_hour) }}</span>
                  </span>
                  <span class="flex align-items-center">
                    <span class="job_content movers-row mr-20 trucks-movers"> <div class="mod-icon mod-icon-movers" />{{
                      claim.job.movers
                    }}</span>
                    <span class="job_content trucks-movers"><span class="mod-icon mod-icon-trucks" />{{
                      claim.job.trucks
                    }}</span>
                  </span>
                </div>
                <div class="row pb-2">
                  <div class="col-md-12">
                    <span class="job_title">Moving company</span><br />
                    <span class="job_content">{{ claim.job.company.name }}</span>
                  </div>
                </div>
                <div class="row pb-2">
                  <div class="col-md-12">
                    <span class="job_title">Carrier</span><br />
                    <span v-if="claim.job.carrier" class="job_content">{{ claim.job.carrier.name }}</span>
                    <span v-else class="job_content">-</span>
                  </div>
                </div>
                <div class="row pb-2">
                  <div class="col-md-6">
                    <span class="job_title">Move date</span><br />
                    <span class="job_content">{{ claim.job.move_date }}</span>
                  </div>
                  <div class="col-md-6">
                    <span class="job_title">Move Duration</span><br />
                    <span class="job_content" v-if="claim.job.total_hours">{{ claim.job.total_hours }}h</span>
                    <span class="job_content" v-else>-</span>
                  </div>
                </div>
                <div class="row pb-2" v-if="showMore === true">
                  <div class="col-md-6">
                    <span class="job_title">Lead created by</span><br />
                    <span class="job_content" v-if="claim.job && claim.job.lead_created_by">{{
                      claim.job.lead_created_by.username
                    }}</span>
                    <span class="job_content" v-else>-</span>
                  </div>
                  <div class="col-md-6">
                    <span class="job_title">Job assigned to</span><br />
                    <span class="job_content" v-if="claim.job.cluster_user !== null">{{
                      claim.job.cluster_user.username
                    }}</span>
                    <span class="job_content" v-else>-</span>
                  </div>
                  <div class="col-md-6 pt-2">
                    <span class="job_title">Min hours</span><br />
                    <span class="job_content">{{ claim.job.minimum_hours }}</span>
                  </div>
                </div>
                <div class="row pb-2">
                  <div class="col-md-12">
                    <span class="show-more" v-if="showMore === false" @click.prevent="showMore = true">Show more</span>
                    <span class="show-more" v-else @click.prevent="showMore = false">Show less</span>
                  </div>
                </div>
              </div>

              <CustomerInfo
                :job="claim.job"
                @openM="showCustomerModal = true"
                @update="getClaim"
              />
            </div>
          </div>
          <div class="right-layout flex">
            <div class="list-box-info col-md-6">
              <div class="container">
                <div class="row booking-indicator">
                  <div class="col-12">
                    <div class="row">
                      <div class="booking-indicator-wrap mt-4" v-if="claim.claim_status.name == 'Closed'">
                        <div class="col-8 px-0">
                          <p>Claim closed with resolution <b>{{ claim.claim_resolution.name }}</b></p>
                        </div>
                        <div class="col-4 px-0 text-right reopen-btn" @click="reopenClaim">
                          <i class="fa fa-repeat reopen-ico" />
                          <p class="reopen-text">Reopen claim</p>
                        </div>
                      </div>

                      <ClaimRefunds :refunds="refunds" :claim="claim" v-if="refunds.length" />

                      <ClaimAssigneInfo :claim-by-id="claim" @update="getClaim" />

                      <ClaimDescription :claim-by-id="claim" @update="getClaim" />

                      <div class="mail-info col-md-12 flex mt-4" :class="[claim.acknowledgement_sent == 0 ? 'mail-orange' : 'mail-green']">
                        <div class="col-md-8">
                          <span v-if="claim.acknowledgement_sent == 0" @click="toggleModal"><i class="fa fa-exclamation-triangle mail-warning-icon" /> <span class="acknowledge-msg">Acknowledgement email has not been sent yet.</span></span>
                          <span v-if="claim.acknowledgement_sent == 1"><i class="fa fa-envelope mail-envelope-icon" /> <span class="acknowledge-msg">Acknowledgement email has been sent.</span></span>
                        </div>
                        <div class="col-md-4 flex flex-justify-end" v-if="claim.acknowledgement_sent == 0">
                          <span @click="toggleSidebar"><i class="fa fa-paper-plane mail-plane-icon" /> <span class="button-send-email">Send email</span></span>
                        </div>
                      </div>

                      <ClaimSettlementAmount :claim="claim" @update="getClaim" />
                      <ClaimAttachments :claim="claim" @update="getClaim" />
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="comments col-md-6">
              <Comments :claim="claim" @update="getClaim" />
            </div>
          </div>
        </div>
      </div>


      <transition name="slide-fade">
        <div class="l-modal-mask"
             v-if="showCustomerModal"
             @click.self="showCustomerModal = false"
        >
          <SideModalCustomerInfo
            v-if="showCustomerModal"
            :claim-id="claim.id"
            :data="claim.job"
            @show-customer-modal-toggle="showCustomerModal = !showCustomerModal"
            @update="getClaim(); getJob()"
            @cancel="showCustomerModal = false"
          />
        </div>
      </transition>

      <transition name="slide-fade">
        <div class="l-modal-mask" v-if="showEmailModal">
          <send-claim-email
            class="sidebar-right"
            :job="claim.job"
            :type-id="2"
            @cancel="toggleSidebar()"
            @update="getClaim"
          />
        </div>
      </transition>

      <modal v-if="ackModal"
             @close="ackModal = false"
             :size="'modal-small'"
             :close-strict="true"
      >
        <div slot="header">
          <div class="row">
            <div class="col-10" />
          </div>
        </div>
        <div slot="body">
          <div class="row text-center mt-3 p-4">
            <h4>This action will mark that the acknowledgement email was sent to the customer. Please confirm to proceed.</h4>
          </div>
        </div>
        <div slot="footer">
          <div class="row mb-2 mt-4">
            <div class="col text-center">
              <button type="button" class="btn btn-secondary" @click="ackModal = false">
                Cancel
              </button>
              <button class="btn btn-primary ld-ext-right"
                      type="button"
                      :class="loadingButton ? 'running' : ''"
                      :disabled="buttonDisabled"
                      @click="overrideAcknowledgement"
              >
                Yes, confirm
                <div class="ld ld-ball ld-flip" />
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
    <vue-content-loading v-else :width="800" :height="450">
      <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
    </vue-content-loading>
  </div>
</template>

<script>
import toastr from 'toastr';
import axios from 'axios';
import LayoutTopNav from './LayoutTopNav';
import CustomerInfo from '../customers/CustomerInfo';
import SideModalCustomerInfo from '../SideModalCustomerInfo';
import ClaimAssigneInfo from './ClaimAssigneInfo';
import Comments from './Comments';
import ClaimSettlementAmount from './ClaimSettlementAmount';
import SendClaimEmail from './Modals/SendClaimEmail';
import Modal from '../Modal';
import ClaimAttachments from './ClaimAttachments';
import ClaimDescription from './ClaimDescription';
import ClaimRefunds from './ClaimRefunds';

export default {
  name: 'ClaimsEdit',
  components: {
    ClaimDescription,
    ClaimRefunds,
    ClaimAttachments,
    ClaimAssigneInfo,
    LayoutTopNav,
    CustomerInfo,
    SideModalCustomerInfo,
    ClaimSettlementAmount,
    Comments,
    SendClaimEmail,
    Modal,
  },
  data: () => ({
    claim: {},
    showMore: false,
    showCustomerModal: false,
    showEmailModal: false,
    ackModal: false,
    loadingButton: false,
    buttonDisabled: false,
    loaded: false,
  }),
  computed: {
    refunds() {
      if (this.claim.job && this.claim.job.charges) {
        return this.claim.job.charges.filter(charge => charge.payment_type_id === 2);
      }
      return [];
    },
  },
  created() {
    this.getClaim();
  },
  methods: {
    getClaim() {
      axios.get(`/claims/${this.$route.params.id}`).then(res => {
        let job = null;
        if (this.claim.job) {
          job = { ...this.claim.job };
        }
        this.claim = res.data.data;
        if (!job) {
          this.getJob();
        } else {
          this.claim.job = job;
        }
      });
    },
    getJob() {
      axios.get(`/jobs/${this.claim.job_id}`).then(result => {
        this.claim.job = result.data.data;
        this.loaded = true;
      });
    },
    reopenClaim() {
      axios
        .put(`/claims/${this.$route.params.id}/`, {
          claim_resolution_id: null,
          claim_status_id: 2,
        })
        .then(() => {
          toastr.success('Claim reopened successfully');
          this.getClaim();
        });
    },
    toggleSidebar() {
      this.showEmailModal = !this.showEmailModal;
    },
    toggleModal() {
      if (this.$_can('claims.acknowledgement.override')) this.ackModal = !this.ackModal;
    },
    overrideAcknowledgement() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      axios
        .patch(`/claims/${this.$route.params.id}`, {
          acknowledgement_sent: true,
        })
        .then(res => {
          this.claim.acknowledgement_sent = res.data.data.acknowledgement_sent;
          this.ackModal = false;
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
  },
};
</script>
<style scoped>
/* Layout */
.align-center {
  align-items: center;
}

.left-layout {
  background-color: #ffffff;
  padding: 0;
  max-width: 324px;
  box-shadow: 1px 0 2px 0 #dee7ef;
}

.right-layout {
  border-left: 1px solid rgba(192, 198, 204, 0.5);
  padding: 0;
  width: calc(100% - 324px);
}
.list-box-info {
  background-color: #f1f4f7;
}

/* End of Layout */

.comments {
  border-left: 1px solid rgba(192, 198, 204, 0.5);
  background-color: #e8ebef;
  padding: 0px;
}

.reopen-btn {
  cursor: pointer;
}

.reopen-ico {
  font-size: 16px;
  letter-spacing: 0.53px;
  line-height: 16px;
  text-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  padding-right: 2.5px;
}

.reopen-text {
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
}

.mod-icon.mod-icon-movers,
.mod-icon.mod-icon-trucks {
  filter: invert(0.3) sepia(0.1) hue-rotate(175deg);
  width: 14px;
  margin-right: 6px;
}
.mod-icon.mod-icon-movers {
  height: 18px;
}
.mod-icon.mod-icon-trucks {
  height: 13px;
  width: 16px;
}

.show-more {
  color: #2962ff;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
}
.job-info .job_ref_id {
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  color: #212529;
}
.job_title {
  color: #808d98;
  font-size: 12px;
  line-height: 16px;
}
.job_content {
  color: #212529;
  font-size: 14px;
  line-height: 20px;
}
.booking-indicator-wrap {
  margin: 0;
}
.booking-indicator .row {
  height: 90vh;
  overflow-y: auto;
}

.mail-info {
  padding: 24px 13px;
}
.mail-orange {
  background-color: #fffcf4;
  border: solid 1px #ffab00;
  border-radius: 4px;
}
.mail-green {
  background-color: #f5fcf3;
  border-radius: 4px;
  border: solid 1px #2db300;
}
.mail-warning-icon {
  font-size: 16px;
  color: #ffab00;
  padding-right: 6px;
  cursor: pointer;
}
.mail-envelope-icon {
  font-size: 16px;
  color: #2db300;
  padding-right: 6px;
}
.mail-plane-icon {
  font-size: 16px;
  color: #ffab00;
  padding-right: 10px;
  cursor: pointer;
}
.acknowledge-msg {
  font-size: 15px;
  color: #4c5669;
  cursor: pointer;
}
.button-send-email {
  color: #ffab00;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}
.price-per-row {
  margin-right: 26px;
}
.trucks-movers {
  font-size: 16px;
}
.mr-20 {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimsEdit.vue